import { addItemToCollection } from "directus/src/operations";

export async function createCountry({ item }) {
  try {
    const data = await addItemToCollection("countries", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
